import axios from 'axios';

// 保存测评项目
export function saveAccessProject(data) {
  return axios({
    url: '/yzdAccess/saveAccessProject',
    method: 'POST',
    data: data,
  });
}
// 删除测评项目
export function delAccessProject(data) {
  return axios({
    url: '/yzdAccess/delAccessProject',
    method: 'POST',
    data: data,
  });
}

// 保存测评项目细则(school:yzdAccess:saveAccessItem)
export function saveAccessItem(data) {
  return axios({
    url: '/yzdAccess/saveAccessItem',
    method: 'POST',
    data: data,
  });
}

// 删除测评项目细则(school:yzdAccess:delAccessItem)
export function delAccessItem(data) {
  return axios({
    url: '/yzdAccess/delAccessItem',
    method: 'POST',
    data: data,
  });
}

// 获取班主任名下班级和项目列表(school:yzdAccess:getClassAndProjectList)
export function getClassAndProjectList(params) {
  return axios({
    url: '/yzdAccess/getClassAndProjectList',
    method: 'GET',
    params: params,
  });
}

// 班级测评项目列表(school:yzdAccess:classAccessProjectList)
export function classAccessProjectList(params) {
  return axios({
    url: '/yzdAccess/classAccessProjectList',
    method: 'GET',
    params: params,
  });
}

// 保存测评记录(school:yzdAccess:saveAccessRecord)
export function saveAccessRecord(data) {
  return axios({
    url: '/yzdAccess/saveAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 删除测评记录(school:yzdAccess:delAccessRecord)
export function delAccessRecord(data) {
  return axios({
    url: '/yzdAccess/delAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 搜索学生(school:yzdAccess:searchStudent)
export function searchStudent(params) {
  return axios({
    url: '/yzdAccess/searchStudent',
    method: 'GET',
    params: params,
  });
}

// 测评记录导出- 管理员 班主任通用(school:yzdAccess:exportAccessRecord)
export function exportAccessRecord(params) {
  return axios({
    url: '/yzdAccess/exportAccessRecord',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 获取测评项目细则下拉选(school:yzdAccess:getAccessItemList)
export function getAccessItemList(params) {
  return axios({
    url: '/yzdAccess/getAccessItemList',
    method: 'GET',
    params: params,
  });
}

// 获取班主任名下班级列表(school:yzdAccess:getClassList)
export function getClassList(params) {
  return axios({
    url: '/yzdAccess/getClassList',
    method: 'GET',
    params: params,
  });
}

// 班主任导出学生总分统计(school:yzdAccess:exportStudentStatistics)
export function exportStudentStatistics(params) {
  return axios({
    url: '/yzdAccess/exportStudentStatistics',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 班主任导出学生总分统计(school:yzdAccess:exportStudentStatistics)
export function exportClassStStatistics(params) {
  return axios({
    url: '/yzdAccess/exportClassStStatistics',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 管理员类目下拉选(school:yzdAccess:adminAccessProjectSelect)
export function adminAccessProjectSelect(params) {
  return axios({
    url: '/yzdAccess/adminAccessProjectSelect',
    method: 'GET',
    params: params,
  });
}

// 数据下拉选
export function selectionList(params) {
  return axios({
    url: '/yzdAccess/selectionList',
    method: 'GET',
    params: params,
  });
}

// 测评统计图(school:yzdAccess:accessStatisticsChart)
export function accessStatisticsChart(params) {
  return axios({
    url: '/yzdAccess/accessStatisticsChart',
    method: 'GET',
    params: params,
  });
}

export function accessStatisticsChartExport(params) {
  return axios({
    url: '/yzdAccess/accessStatisticsChartExport',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 获取年级主任名下年级
export function getGradeList(params) {
  return axios({
    url: '/gradeAccess/getGradeList',
    method: 'GET',
    params: params,
  });
}

// Grade dropdown data
export function gradeSelectionList(params) {
  return axios({
    url: '/gradeAccess/selectionList',
    method: 'GET',
    params: params,
  });
}

// 保存年级测评项目
export function saveGradeAccessProject(data) {
  return axios({
    url: '/gradeAccess/saveAccessProject',
    method: 'POST',
    data: data,
  });
}

// 删除年级测评项目
export function delGradeAccessProject(data) {
  return axios({
    url: '/gradeAccess/delAccessProject',
    method: 'POST',
    data: data,
  });
}

// 保存年级测评项目细则
export function saveGradeAccessItem(data) {
  return axios({
    url: '/gradeAccess/saveAccessItem',
    method: 'POST',
    data: data,
  });
}

// 删除年级测评项目细则
export function delGradeAccessItem(data) {
  return axios({
    url: '/gradeAccess/delAccessItem',
    method: 'POST',
    data: data,
  });
}

// 保存年级测评记录
export function saveGradeAccessRecord(data) {
  return axios({
    url: '/gradeAccess/saveAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 删除年级测评记录
export function delGradeAccessRecord(data) {
  return axios({
    url: '/gradeAccess/delAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 年级测评记录导出
export function exportGradeAccessRecord(params) {
  return axios({
    url: '/gradeAccess/exportAccessRecord',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 获取年级测评项目细则列表
export function gradeAccessItemPage(params) {
  return axios({
    url: '/gradeAccess/getAccessItemPage',
    method: 'GET',
    params: params,
  });
}

// Grade access item dropdown
export function getGradeAccessItemList(params) {
  return axios({
    url: '/gradeAccess/getAccessItemList',
    method: 'GET',
    params: params,
  });
}

// 获取年级主任名下年级和项目列表
export function getGradeAndProjectList(params) {
  return axios({
    url: '/gradeAccess/getGradeAndProjectList',
    method: 'GET',
    params: params,
  });
}

// 年级测评项目列表
export function gradeAccessProjectList(params) {
  return axios({
    url: '/gradeAccess/gradeAccessProjectList',
    method: 'GET',
    params: params,
  });
}

// 获取年级主任名下班级列表
export function getClassListForGrade(params) {
  return axios({
    url: '/gradeAccess/getClassListForGrade',
    method: 'GET',
    params: params,
  });
}

// 年级测评各班总分统计
export function gradeAccessStatisticsPage(params) {
  return axios({
    url: '/gradeAccess/gradeAccessStatisticsPage',
    method: 'GET',
    params: params,
  });
}

// 导出班级总分统计
export function gradeExportClassStStatistics(params) {
  return axios({
    url: '/gradeAccess/exportClassStStatistics',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 年级搜索学生
export function gradeSearchStudent(params) {
  return axios({
    url: '/gradeAccess/searchStudent',
    method: 'GET',
    params: params,
  });
}

// 年级测评统计图
export function gradeAccessStatisticsChart(params) {
  return axios({
    url: '/gradeAccess/accessStatisticsChart',
    method: 'GET',
    params: params,
  });
}

// 年级测评统计图导出
export function gradeAccessStatisticsChartExport(params) {
  return axios({
    url: '/gradeAccess/accessStatisticsChartExport',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}
